@if (store()) {
    <div class="indicator" [ngClass]="{'open': isOpen()}">
    </div>
}
<div class="details">
    <div class="details-title" woa-activatable (onActivate)="toggleHours(hours)" woa-touchable>
        <div class="details-title-label">
            {{ statusLabel() | translate }}
        </div>
        <woa-toggle class="details-title-toggle" [active]="showHours()"></woa-toggle>
    </div>
    <div class="details-hours" #hours>
        @for (day of daysOfWeek; track day) {
            <div class="details-hours-item">
                <!-- WHEN THERE ARE OPENING HOURS -->
                <!--suppress JSUnresolvedReference -->
                @for (hours of store().storeOpeningHours.standardHours[day].hours; track hours; let isFirst = $first) {
                    <div class="details-hours-item-time">
                        <div class="details-hours-item-time-day" id="open-day-{{day}}">
                            @if (isFirst) {
                                {{ 'woa.label.common.day.' + day | translate }}
                            }
                        </div>
                        <div class="details-hours-item-time-hours">
                            <div class="details-hours-item-time-hours-start" id="open-time-{{day}}-start">
                                {{ hours.start | woaTime:'hh:mm a' }}
                            </div>
                            -
                            <div class="details-hours-item-time-hours-end" id="open-time-{{day}}-end">
                                {{ hours.end | woaTime:'hh:mm a' }}
                            </div>
                        </div>
                    </div>
                }
                <!-- WHEN STORE IS CLOSED FOR THE DAY -->
                <!--suppress JSUnresolvedReference -->
                @if (store().storeOpeningHours.standardHours[day].closedForTheDay) {
                    <div class="details-hours-item-time">
                        <div id="closed-day-{{day}}" class="details-hours-item-time-day">
                            <ng-container>{{ 'woa.label.common.day.' + day | translate }}</ng-container>
                        </div>
                        <div id="closed-time-{{day}}" class="details-hours-item-time-hours">
                            {{ 'woa.label.store-details.storeClosedForTheDay' | translate }}
                        </div>
                    </div>
                }
            </div>
        }
    </div>
</div>
